import React, { Component } from "react";
import { Card, CardHeader, CardBody, Row, Col, Table, Badge } from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import TableScrollbar from "react-table-scrollbar";
import moment from "moment";
import DefaultImg from "../../assets/images/product/Default_img.jpg";
import { AuditPopRight } from "../../store/Audit_Report/actions";

import { productItemHistoryModelOpen } from "../../store/MaterialRequest/actions";
import ProductItemHistoryLog from "../Material/ProductItemHistoryLog";
class MaterialRequestCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			item_details: {},
			maximize: true,
		};

		this.tog_static = this.tog_static.bind(this);
	}
	tog_static(item) {
		this.setState((prevState) => ({
			modal_static: !prevState.modal_static,
			item_details: item,
		}));

		this.removeBodyCss();
	}

	removeBodyCss() {
		document.body.classList.add("no_padding");
	}

	maximizetogle() {
		this.setState((prevState) => ({
			maximize: !prevState.maximize,
		}));
	}
	callNextCard(id) {
		if (this.props.AuditData.length - 1 === this.props.index) {
			this.props.getAuditMRRowData({
				ScreenID: id,
			});
			this.setState((prevState) => ({
				maximize: !prevState.maximize,
			}));
		}
	}

	render() {
		var obj = {};
		obj = this.props.obj;
		return (
			<div className={this.state.maximize ? "maximize" : "minimize"}>
				<>
					<Row className="plaseholder">
						<Col>
							<Card>
								<CardHeader className="bg-transparent border-bottom ">
									<h5 className="card-title-18 pt-2 d-inline-block">
										Material Request
									</h5>
								</CardHeader>
								<CardBody className="pt-1 ">
									<Row className="p-1">
										<Col xl={4} className="p-1">
											<Card className="p-1 bg-light">
												<CardHeader
													className="bg-transparent"
													style={{
														borderBottom:
															"1px solid #d9d9d9",
													}}>
													<h3 className="card-title-15">
														REQUEST DETAILS (
														<span>
															<b>
																{obj.data.code}
															</b>
														</span>
														)
													</h3>
												</CardHeader>
												<CardBody className="pt-1 bg-light">
													<Row className="p-0">
														<Col
															md="12"
															className="p-1 m-0">
															<div className="Order-panel-content">
																<div className="list-column">
																	<ul className="list-style-three p-0">
																		<li className="clearfix">
																			<span className="ttl">
																				HOD(U)
																				Approved
																				by:
																			</span>
																			<span className="dtl">
																				{obj
																					.data
																					.userDeptApprovedby &&
																					obj
																						.data
																						.userDeptApprovedby[
																						obj
																							.data
																							.userDeptApprovedby
																							.length -
																							1
																					]
																						?.approvedby
																						.fullname}
																			</span>
																		</li>
																		<li className="clearfix">
																			<span className="ttl">
																				HOD(U)
																				Approved
																				Date:
																			</span>
																			<span className="dtl">
																				{moment(
																					obj
																						.data
																						.userDeptApprovedby &&
																						obj
																							.data
																							.userDeptApprovedby[
																							obj
																								.data
																								.userDeptApprovedby
																								.length -
																								1
																						]
																							?.createdon
																				).format(
																					"DD-MM-YYYY"
																				)}
																			</span>
																		</li>
																		<li className="clearfix">
																			<span className="ttl">
																				Location:
																			</span>
																			<span className="dtl">
																				{
																					obj
																						.data
																						.location
																						?.name
																				}
																			</span>
																		</li>
																		<li className="clearfix">
																			<span className="ttl">
																				Sub
																				Location:
																			</span>
																			<span className="dtl">
																				{
																					obj
																						.data
																						.sublocation
																						?.name
																				}
																			</span>
																		</li>
																		{/* <li className="clearfix">
                                          <span className="ttl">
                                            Department:
                                          </span>
                                          <span className="dtl">
                                            {
                                              obj.data.department
                                                ?.name
                                            }
                                          </span>
                                        </li> */}
																		<li className="clearfix">
																			<span className="ttl">
																				User
																				Department:
																			</span>
																			<span className="dtl">
																				{
																					obj
																						.data
																						.userdepartment
																						?.name
																				}
																			</span>
																		</li>
																		<li className="clearfix">
																			<span className="ttl">
																				User
																				Name:
																			</span>
																			<span className="dtl">
																				{
																					obj
																						.data
																						.createdby
																						?.fullname
																				}
																			</span>
																		</li>
																		<li className="clearfix">
																			<span className="ttl">
																				Submited
																				Date:
																			</span>
																			<span className="dtl">
																				{moment(
																					obj
																						.data
																						.createdon
																				).format(
																					"DD-MM-YYYY"
																				)}
																			</span>
																		</li>
																		<li className="clearfix">
																			<span className="ttl">
																				Required
																				Date:
																			</span>
																			<span className="dtl">
																				{moment(
																					obj
																						.data
																						.date
																				).format(
																					"DD-MM-YYYY"
																				)}
																			</span>
																		</li>
																		<li className="clearfix">
																			<span className="ttl">
																				Description:
																			</span>
																			<span className="dtl">
																				{
																					obj
																						.data
																						.description
																				}
																			</span>
																		</li>
																		{(obj
																			.data
																			.mrstatus ===
																			4 ||
																			obj
																				.data
																				.mrstatus ===
																				6) && (
																			<li className="clearfix">
																				<span className="ttl text-danger ">
																					Reject
																					Remark
																					:
																				</span>
																				<span className="dtl">
																					{
																						obj
																							.data
																							.mr_approvals[
																							obj
																								.data
																								.mr_approvals
																								.length -
																								1
																						]
																							.description
																					}
																				</span>
																			</li>
																		)}
																	</ul>
																</div>
															</div>
														</Col>
														{/* <Col md={12}>
                              {(obj.data.mrstatus === 1 ||
                                obj.data.mrstatus === 2) && (
                                <div className="text-center border-bottom">
                                  <Label className="font-size-24  text-primary">
                                    Pending
                                  </Label>
                                </div>
                              )}
                              {obj.data.mrstatus === 3 && (
                                <div className="text-center border-bottom">
                                  <Label className="font-size-24  text-success">
                                    HOD Approved
                                  </Label>
                                </div>
                              )}

                              {(obj.data.mrstatus === 5 ||
                                obj.data.mrstatus === 7 ||
                                obj.data.mrstatus === 8) && (
                                <div className="text-center border-bottom">
                                  <Label className="font-size-24  text-success">
                                    Admin Approved
                                  </Label>
                                </div>
                              )}
                              {obj.data.mrstatus === 4 && (
                                <div className="text-center ">
                                  <Label className="font-size-24  text-danger">
                                    HOD Rejected
                                  </Label>
                                </div>
                              )}
                              {obj.data.mrstatus === 6 && (
                                <div className="text-center ">
                                  <Label className="font-size-24  text-danger">
                                    Admin Rejected
                                  </Label>
                                </div>
                              )}  </Col> */}
													</Row>
												</CardBody>
											</Card>
										</Col>
										<Col xl={8}>
											<Card className="p-1">
												<CardBody className="pt-1">
													<Row>
														<Col md={12}>
															<h3 className="card-title-15 pt-2">
																Request Items
																List
															</h3>
														</Col>
													</Row>
													<Row className="p-0">
														<Col
															md={12}
															className="m-1">
															<div className="table-responsive m-0">
																<TableScrollbar height="400px">
																	<Table
																		striped
																		bordered
																		hover
																		className="mb-0 p-0 table-centered">
																		<thead className="bg-light text-center">
																			<tr>
																				<th className="nowrap">
																					Item
																					Images
																				</th>
																				<th
																					style={{
																						minWidth:
																							"220px",
																					}}>
																					Item
																					Name
																				</th>
																				<th className="nowrap">
																					Quantity
																				</th>
																				<th className="nowrap">
																					Approved
																					Quantity
																				</th>
																				<th className="nowrap">
																					Action
																				</th>
																			</tr>
																		</thead>
																		<tbody>
																			{obj.data?.mritems?.map(
																				(
																					item,
																					key
																				) => (
																					<tr
																						key={
																							key
																						}>
																						<td className="text-center">
																							<div className="product-detail text-center">
																								<img
																									src={
																										item
																											?.product
																											?.image ==
																										null
																											? DefaultImg
																											: item
																													?.product
																													?.image
																									}
																									alt="product-img"
																									title="product-img"
																									className="product-img  img-fluid mx-auto tab-img rounded"
																									style={{
																										height: "100px",
																										width: "150px",
																									}}
																								/>
																							</div>
																							{/* <img
                                                    src={
                                                      item?.product?.image ==
                                                      null
                                                        ? DefaultImg
                                                        : item?.product?.image
                                                    }
                                                    alt="product-img"
                                                    title="product-img"
                                                    className="avatar-sm"
                                                  /> */}
																						</td>
																						<td>
																							<h5 className="font-size-14 ">
																								<Link
																									to="#"
																									onClick={() => {
																										this.tog_static(
																											item
																										);
																									}}
																									className="text-dark">
																									{!item
																										.product
																										.active && (
																										<i className="text-danger ri-spam-line mr-1"></i>
																									)}
																									{
																										item
																											?.product
																											?.name
																									}
																								</Link>
																								{item
																									.mri_approvals
																									.length !==
																									0 && (
																									<>
																										<Link
																											to="#"
																											onClick={() => {
																												this.props.productItemHistoryModelOpen(
																													item.mri_approvals
																												);
																											}}
																											className="text-dark">
																											<i className=" text-primary ri-eye-fill ml-2"></i>
																										</Link>
																									</>
																								)}
																								{item
																									.mri_approvals
																									.length !==
																									0 && (
																									<>
																										{(item
																											.mri_approvals[0]
																											?.mrstatus ===
																											9 ||
																											item
																												.mri_approvals[0]
																												?.mrstatus ===
																												10) && (
																											<>
																												<br />
																												<spam className="font-size-12 text-danger">
																													({" "}
																													<del>
																														{
																															item
																																.mri_approvals[0]
																																?.f_product
																																.name
																														}
																													</del>{" "}
																													)
																												</spam>
																											</>
																										)}
																									</>
																								)}
																							</h5>
																							<p className="mb-0">
																								Make
																								:{" "}
																								<span className="font-weight-medium">
																									{
																										item.make
																									}
																								</span>
																							</p>
																							<p className="mb-0">
																								Description
																								:{" "}
																								<span className="font-weight-medium">
																									{
																										item.description
																									}
																								</span>
																							</p>
																							{(item.mrstatus ===
																								4 ||
																								item.mrstatus ===
																									6) && (
																								<p className="mb-0">
																									<b className="text-danger ">
																										Reject
																										Remark
																										:
																									</b>{" "}
																									<span>
																										{
																											item
																												.mri_approvals[
																												item
																													.mri_approvals
																													.length -
																													1
																											]
																												.description
																										}
																									</span>
																								</p>
																							)}
																						</td>
																						<td className="text-center">
																							{item
																								.mri_approvals
																								.length ===
																							0
																								? item.qty +
																								  " " +
																								  item
																										.unit
																										?.name
																								: item
																										.mri_approvals[0]
																										.f_qty +
																								  " " +
																								  item
																										.mri_approvals[0]
																										.f_unit
																										.name}
																						</td>

																						<td className="text-center">
																							{
																								item.qty
																							}{" "}
																							{
																								item
																									.unit
																									?.name
																							}
																						</td>

																						<td className="nowrap text-center">
																							{(item.mrstatus ===
																								1 ||
																								item.mrstatus ===
																									2) && (
																								<Badge
																									className="font-size-14"
																									color="primary">
																									Pending
																								</Badge>
																							)}
																							{item.mrstatus ===
																								3 && (
																								<Badge
																									className="font-size-14"
																									color="success">
																									HOD
																									Approved
																								</Badge>
																							)}
																							{item.mrstatus ===
																								4 && (
																								<Badge
																									className="font-size-14"
																									color="danger">
																									HOD
																									Rejected
																								</Badge>
																							)}
																							{(item.mrstatus ===
																								5 ||
																								item.mrstatus ===
																									7 ||
																								item.mrstatus ===
																									8) && (
																								<Badge
																									className="font-size-14"
																									color="success">
																									Admin
																									Approved
																								</Badge>
																							)}
																							{item.mrstatus ===
																								6 && (
																								<Badge
																									className="font-size-14"
																									color="danger">
																									Admin
																									Rejected
																								</Badge>
																							)}
																						</td>
																					</tr>
																				)
																			)}
																		</tbody>
																	</Table>
																</TableScrollbar>
															</div>
														</Col>
													</Row>
												</CardBody>
											</Card>
										</Col>
									</Row>
									<ProductItemHistoryLog />
								</CardBody>
							</Card>
						</Col>
					</Row>
					<Link
						to="#"
						className="strip"
						onClick={() => {
							this.maximizetogle();
							this.props.AuditPopRight(this.props.index);
						}}>
						<div className="MaximizeCard-item mb-2 ">
							<div className="MaximizeCard-title-box d-inline-block">
								<span className="mt-4">
									Material Request ({obj.data.code})
								</span>
							</div>
						</div>
					</Link>
				</>
			</div>
		);
	}
}
const mapStatetoProps = (state) => {
	const { AuditData } = state.AuditReport;
	return { AuditData };
};

export default connect(mapStatetoProps, {
	AuditPopRight,
	productItemHistoryModelOpen,
})(MaterialRequestCard);
